<kodit-list [items]="stanList" [listConfig]="listConfig"></kodit-list>
